<template>
  <div>
    <div class="d-flex">
      <nav id="breadcrumbs" class="mb-3">
        <ul>
          <li>
            <router-link :to="{ name: 'company.dashboard' }">
              <a href="#"> <i class="uil-home-alt"></i> </a>
            </router-link>
          </li>
          <li>
            <span> {{
                this.$t('report.company_dashboard.reports')
              }}
            </span>
          </li>
          <li>{{ $t('general.user_cumulative_reports') }}</li>
        </ul>
      </nav>
    </div>

    <div class="section-header mb-lg-2 border-0 uk-flex-middle">
      <div class="section-header-left">
        <h2 class="uk-heading-line text-left">
          <span> {{ $t("users.users") }} </span>
        </h2>
      </div>
    </div>
    <div class="card">
      <!-- Card header -->
      <div class="card-header actions-toolbar border-0">
        <div class="d-flex justify-content-between align-items-center">
          <div class="row" style="width:100%">
            <div class=" col-md-1  search-icon ">
              <i class="uil-search"></i>
            </div>
            <div class="col-md-11 uk-search uk-search-navbar" style="margin-left:-2rem">
              <input v-model="filter.search" :placeholder="$t('general.search')" autofocus=""
                     class="uk-search-input shadow-0 uk-form-small" type="search"/>
            </div>
          </div>
          <div class="d-flex">
            <a :uk-tooltip="$t('filters.order.sort')" aria-expanded="false" class="btn btn-icon btn-hover  btn-circle"
               href="javascript:void(0)" title="">
              <i class="uil-list-ui-alt"></i>
            </a>
            <div class="uk-dropdown" uk-dropdown="pos: bottom-right ; mode: click ;animation: uk-animation-scale-up">
              <ul class="uk-nav uk-dropdown-nav">
                <li class="uk-active">
                  <a href="javascript:void(0)" @click="sortOrder('asc', 'name')">{{ $t("sorting.a_z") }}</a>
                </li>
                <li>
                  <a href="javascript:void(0)" @click="sortOrder('desc', 'name')">{{ $t("sorting.z_a") }}</a>
                </li>
                <li>
                  <a href="javascript:void(0)" @click="sortOrder('asc', 'id')">
                    {{ $t("sorting.created_at_old") }}</a>
                </li>
                <li>
                  <a href="javascript:void(0)" @click="sortOrder('desc', 'id')">
                    {{ $t("sorting.created_at_new") }}</a>
                </li>
              </ul>
            </div>
            <a :uk-tooltip="$t('general.filter_list')" class="btn btn-icon btn-hover btn-circle"
               href="javascript:void(0)">
              <i class="uil-filter"></i>
            </a>
            <UserFilter :has-status="true" @getFilter="getFilter($event)"/>

            <excel-download-button :loading="isReportDownloading"
                                   :tooltipText="$t('filters.export_excell')"
                                   @download="exportUsers"
            />
          </div>
        </div>
      </div>
      <!-- Table -->
      <default-loading v-if="user_loading"></default-loading>
      <template v-else>
        <div class="table-responsive">
          <table class="table align-items-center">
            <thead>
            <tr>
              <th scope="col">{{ $t("users.photo") }}</th>
              <th scope="col">ID</th>
              <th scope="col">
                {{ $t("users.firstname") }} {{ $t("users.lastname") }}
              </th>
              <th scope="col">{{ $t("users.user_email") }}</th>
              <th scope="col">{{ $t("general.phone") }}</th>
              <th scope="col">{{ $t('general.user_status') }}</th>
              <th scope="col">{{ $t("users.reg_no") }}</th>
              <th scope="col">{{ $t("users.title") }}</th>
              <th scope="col">{{ $t("gender.gender") }}</th>
              <th scope="col">{{ $t("users.mission") }}</th>
              <th scope="col">{{ $t("users.branch") }}</th>
              <th scope="col">{{ $t("users.area") }}</th>
              <th scope="col">{{ $t("users.department") }}</th>
              <th scope="col">{{ $t("general.corporation") }}</th>

              <th scope="col">{{ $t('general.assignments_total') }}</th>
              <th scope="col">{{ $t('general.assignments_not_started') }}</th>
              <th scope="col">{{ $t('general.assignments_started') }}</th>
              <th scope="col">{{ $t('general.assignments_completed') }}</th>

              <th scope="col">{{ $t('general.trainings_total') }}</th>
              <th scope="col">{{ $t('general.trainings_not_started') }}</th>
              <th scope="col">{{ $t('general.trainings_started') }}</th>
              <th scope="col">{{ $t('general.trainings_completed') }}</th>

              <th scope="col">{{ $t('general.total_points') }}</th>
              <th scope="col">{{ $t('general.total_coins') }}</th>
              <th scope="col">{{ $t('excel.heading.completed_contents_duration_sum') }} (dk)</th>

              <th scope="col">{{ $t("users.last_login_date") }}</th>
              <th scope="col">{{ $t("general.created_at") }}</th>
              <th scope="col"></th>
            </tr>
            </thead>
            <tbody class="list">
            <template v-for="item in formattedItems">
              <tr>
                <th scope="row">
                  <div class="media align-items-center">
                    <div>
                      <div class="avatar-parent-child" style="width: max-content">
                        <AvatarOrIcon :alt="item.name + ' ' + item.surname" :size-px="32" :src="item.photo_link"/>
                      </div>
                    </div>
                  </div>
                </th>
                <td>{{ item.id }}</td>
                <td>{{ item.name }} {{ item.surname }}</td>
                <td>{{ item.email }}</td>
                <td>{{ item.phone }}</td>
                <td>{{ item.status }}</td>
                <td>{{ item.registration_number }}</td>
                <td>{{ item.title }}</td>
                <td>{{ item.gender }}</td>
                <td>{{ item.position }}</td>
                <td>{{ item.branch }}</td>
                <td>{{ item.region }}</td>
                <td>{{ item.department }}</td>
                <td>{{ item.corporate }}</td>

                <td>{{ item.assignments_total }}</td>
                <td>{{ item.assignment_not_started_count }}</td>
                <td>{{ item.assignments_started_count }}</td>
                <td>{{ item.assignments_completed_count }}</td>

                <td>{{ item.trainings_total }}</td>
                <td>{{ item.training_not_started_count }}</td>
                <td>{{ item.training_started_count }}</td>
                <td>{{ item.training_completed_count }}</td>

                <td>{{ item.point_sum }}</td>
                <td>{{ item.coin_sum }}</td>
                <td>{{ item.completed_contents_duration_sum }}</td>

                <td>{{ item.last_login_at }}</td>
                <td>{{ item.created_at }}</td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
        <pagination :pagination="pagination" class="mt-2 mb-3" @changePage="setPage($event)"></pagination>
      </template>
    </div>
  </div>
</template>

<script>
import reports, {
  GET_ITEMS,
  LOADING,
  MODULE_NAME,
  SUCCESS,
} from "@/core/services/store/reports.module";

import store from "@/core/services";
import moment from "moment";
import axios from "axios";
import Pagination from "@/assets/components/Pagination";
import DefaultLoading from "@/view/components/loading/DefaultLoading";
import UserFilter from "@/view/company/User/Filter";
import AvatarOrIcon from "@/view/components/icons/AvatarOrIcon.vue";
import ExcelDownloadButton from "@/view/components/buttons/ExcelDownloadButton.vue";
import {
  getAssignedCorporateAccess,
  applyAssignedCorporateToFilter,
} from "@/core/services/userCorporateAccess.service";

const _MODULE_NAME = MODULE_NAME;

export default {
  name: "ReportUsers",
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_MODULE_NAME, reports);
  },
  components: { Pagination, DefaultLoading, UserFilter, AvatarOrIcon, ExcelDownloadButton },
  data() {
    return {
      pagination: null,
      page: 1,
      per_page: 10,
      formattedItems: [],
      filter: {
        search: null,
        order: "desc",
        sort: "id",
      },
      keepFilter: null,
      from_date: null,
      to_date: null,
      user_status: null,
      isReportDownloading: false
    };
  },
  computed: {
    user_loading() {
      return store.getters[_MODULE_NAME + "/" + LOADING];
    },
    success() {
      return store.getters[_MODULE_NAME + "/" + SUCCESS];
    },
  },
  methods: {
    getPhoneNumber(user) {
      return (!user.country_phone_code || !user.phone) ? '-' : `+${user.country_phone_code}${user.phone}`;
    },
    exportUsers() {
      //  indirme işlemi devam edyorsa, yeni istek yapmaa
      if (this.isReportDownloading) {
        return;
      }

      let self = this;
      this.isReportDownloading = true;
      let filters = {
        page: this.page,
        per_page: this.per_page,
        sort: this.filter.sort,
        order: this.filter.order,
      };
      if (this.keepFilter) {
        const keepFilter = this.keepFilter;

        if (keepFilter.company_id) {
          filters['company_id'] = keepFilter.company_id;
        }

        // {id, name} listesi tutan filtreler API için id dizisine çevrilir
        Object.entries(keepFilter).forEach(([key, value]) => {
          if (Array.isArray(value) && value.length > 0) {
            filters[key] = JSON.stringify(value.map((item) => item.id));
          }
        });
      }
      axios
          .get(process.env.VUE_APP_BACKEND_APP_URL + "/api/report/export/users?sort=" +
              this.filter.sort +
              "&order=" +
              this.filter.order
              + (filters['branch_id'] ?
                  ("&branch_id=" + filters['branch_id']) : '')
              + (filters['department_id'] ?
                  ("&department_id=" + filters['department_id']) : '')
              + (filters['region_id'] ?
                  ("&region_id=" + filters['region_id']) : '')
              + (filters['title_id'] ?
                  "&title_id=" + filters['title_id'] : '')
              + (filters['position_id'] ?
                  ("&position_id=" + filters['position_id']) : '')
              + (filters['corporate_id'] ?
                  ("&corporate_id=" + filters['corporate_id']) : '') +
              "&with_statistics=true" +
              (this.from_date ? ("&from_date=" + this.from_date) : '') +
              (this.to_date ? ("&to_date=" + this.to_date) : '') + "&report=" + Math.random() * 9999999, {
            responseType: "blob",
            params: {
              user_status: this.user_status
            },
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.secureLocalStorage("token"),
            },
          })
          .then((response) => {
            let fileURL = window.URL.createObjectURL(new Blob([response.data]));
            let fileLink = document.createElement("a");
            fileLink.href = fileURL;
            let day = moment().format("YYYYMMDDHHMMSS");
            let fileName = "users_report_list_" + day + ".xlsx";
            fileLink.setAttribute("download", fileName);
            document.body.appendChild(fileLink);
            fileLink.click();

            self.isReportDownloading = false;
          })
          .catch(() => {
            self.isReportDownloading = false;
          });
    },
    filterResult(filter = null) {
      let self = this;
      if (filter) {
        this.keepFilter = filter;
        this.from_date = filter.from_date
        this.to_date = filter.to_date
        this.user_status = filter.user_status
      }
      let filters = {
        like: self.filter.search,
        page: self.page,
        per_page: self.per_page,
        sort: self.filter.sort,
        order: self.filter.order,
        with_statistics: true
      };

      // İstek her zaman saklanan son filtreden (keepFilter) kurulur;
      // böylece sayfalama/sıralama sırasında filtreler kaybolmaz
      const activeFilter = this.keepFilter || {};

      if (activeFilter.company_id) {
        filters['company_id'] = activeFilter.company_id;
      }

      // {id, name} listesi tutan filtreler API için id dizisine çevrilir
      Object.entries(activeFilter).forEach(([key, value]) => {
        if (Array.isArray(value) && key !== 'company_id') {
          filters[key] = JSON.stringify(value.map((item) => item.id));
        }
      });

      this.from_date ? filters['from_date'] = this.from_date : null
      this.to_date ? filters['to_date'] = this.to_date : null
      filters['user_status'] = this.user_status

      store
          .dispatch(_MODULE_NAME + "/" + GET_ITEMS, {
            url: "api/report/users",
            filters: filters,
          })
          .then((response) => {
            if (response.status) {
              let results = [];
              let items = response.data;
              this.pagination = items;
              items.data.forEach((item) => {
                results.push({
                  id: item.id,
                  name: item.name,
                  email: item.email,
                  photo_link: item.photo_link,
                  surname: item.surname,
                  status: item.status_id == 0 ? this.$t("general.passive") : this.$t("general.active"),
                  registration_number: item.registration_number ?? "-",
                  title: item.title ? item.title.name : "-",
                  gender: item.gender ? this.$t("gender." + item.gender.key) : "-",
                  region: item.region ? item.region.name : "-",
                  position: item.position ? item.position.name : "-",
                  department: item.department ? item.department.name : "-",
                  corporate: item.corporate ? item.corporate.name : "-",
                  branch: item.branch ? item.branch.name : "-",
                  last_login_at: item.last_login_at
                      ? moment(item.last_login_at).format("DD/MM/YYYY HH:mm:ss")
                      : "-",
                  //yeni veriler
                  assignments_total: item.assignments_count ? item.assignments_count : "-",
                  assignment_not_started_count: item.assignment_not_started_count ? item.assignment_not_started_count : "-",
                  assignments_started_count: item.assignments_started_count ? item.assignments_started_count : "-",
                  assignments_completed_count: item.assignments_completed_count ? item.assignments_completed_count : "-",

                  trainings_total: item.trainings_count ? item.trainings_count : "-",
                  training_not_started_count: item.training_not_started_count ? item.training_not_started_count : "-",
                  training_started_count: item.training_started_count ? item.training_started_count : "-",
                  training_completed_count: item.training_completed_count ? item.training_completed_count : "-",

                  point_sum: item.point_sum ? item.point_sum : "-",
                  coin_sum: item.coin_sum ? item.coin_sum : "-",
                  completed_contents_duration_sum: item.completed_contents_duration_sum ? item.completed_contents_duration_sum : "-",
                  created_at: item.created_at
                      ? moment(item.created_at).format("DD/MM/YYYY HH:mm:ss")
                      : "-",
                  phone: this.getPhoneNumber(item)
                });
              });
              this.formattedItems = results;
            }
          });
    },
    sortOrder(order, sort) {
      this.page = 1;
      this.filter.order = order;
      this.filter.sort = sort;
      this.filterResult();
    },
    setPage(page) {
      this.page = page;
      this.filterResult();
    },
    getFilter(value) {
      this.page = 1;
      this.filterResult(value);
    },
  },
  async mounted() {
    // company_admin değilse ve bir şirkete atanmışsa
    // ilk yüklemede sadece o şirketin verisi gelsin
    const corporateAccess = await getAssignedCorporateAccess();
    this.keepFilter = applyAssignedCorporateToFilter(this.keepFilter, corporateAccess);

    this.filterResult();
    this.debouncedFilterSearch = _.debounce(this.filterResult, 500);
  },
  watch: {
    success: function (val) {
      if (val) {
        this.filterResult();
      }
    },
    "filter.search": function () {
      this.debouncedFilterSearch();
    },
  },
};
</script>

<style scoped>
input[type="button"],
input[type="submit"],
span.btn,
.btn {
  display: inline-block;
}

.uk-alert {
  margin: 0;
}
</style>
